import React, { FC } from 'react';
import { Typography } from '@mui/material';
import useStyles from './styles';

type ErrorMessage = { heading: string; description: string };

const ErrorPage: FC<ErrorMessage> = ({ heading, description }: ErrorMessage) => {
  const classes = useStyles();
  return (
    <div className={classes.pageContainer}>
      <Typography variant="h1" className={classes.title}>
        {heading}
      </Typography>
      <Typography className={classes.message}>{description}</Typography>
    </div>
  );
};

export default ErrorPage;
